import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';
import { createOptions } from 'apps/web/types/option';

export const DIGITAL_PERCEPTION_VERBS: BehavioralVerb[] = createOptions([
  'Finding',
  'Identifying',
  'Locating',
  'Searching',
]);

export const DIGITAL_SET_VERBS: BehavioralVerb[] = createOptions([
  'Loading',
  'Matching',
  'Preparing',
  'Selecting',
]);

export const DIGITAL_GUIDED_RESPONSE_VERBS: BehavioralVerb[] = createOptions([
  'Acting Out',
  'Hacking',
  'Interviewing',
  'Painting',
  'Playing',
  'Reenacting',
  'Sketching',
]);

export const DIGITAL_MECHANISM_VERBS: BehavioralVerb[] = createOptions([
  'Executing',
  'Experimenting',
  'Implementing',
  'Programming',
  'Simulating',
]);

export const DIGITAL_COMPLEX_OVERT_RESPONSE_VERBS: BehavioralVerb[] =
  createOptions([
    'Animating',
    'Building',
    'Designing',
    'Directing',
    'Filming',
    'Operating',
  ]);

export const DIGITAL_ADAPTATION_VERBS: BehavioralVerb[] = createOptions([
  'Adapting',
  'Modifying (Implied in devising/creating)',
  'Remixing',
  'Solving',
]);

export const DIGITAL_ORIGINATION_VERBS: BehavioralVerb[] = createOptions([
  'Composing',
  'Creating',
  'Devising',
  'Leading',
]);
